import React from 'react'
import PropTypes from 'prop-types'

// Componenets
import Tooltip from 'antd/lib/tooltip'
import IconInfomation from 'ui/Icons/IconInfomation'

// Styles
import './Tooltip.scss'

export const Text = ({
  color,
  trigger,
  placement,
  title,
  overlayStyle,
  children,
  ...props
}) => {
  return (
    <Tooltip
      color={color}
      overlayStyle={overlayStyle}
      overlayClassName="tooltip-overlay"
      title={title}
      placement={placement}
      trigger={trigger}
      {...props}
    >
      {''}
      {children}
    </Tooltip>
  )
}

// Props
Text.propTypes = {
  color: PropTypes.string,
  overlayStyle: PropTypes.object,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  placement: PropTypes.string,
  trigger: PropTypes.string,
}

Text.defaultProps = {
  color: '#EFF7FF',
  overlayStyle: {},
  title: '',
  children: <IconInfomation />,
  placement: 'rightTop',
  trigger: 'click',
}

export default Text
